<template>
  <div>
    <button class="expandPanel" @click="collapse">
      <p>{{ parseTranslation(GROUP_ADVANCED_SETTINGS) }}</p>

      <span :class="{ active: collapseGroupAdvancedOptions }">
        <Arrow />
      </span>
    </button>

    <div v-if="collapseGroupAdvancedOptions" class="collapsePanel">
      <div v-for="(advancedOption, index) in optionsToRender()" :key="advancedOption">
        <component
          :is="getComponent(groupAdvancedOptionsToRenderConfig[advancedOption].type)"
          :id="`group-${questions_groups_index}-options-${advancedOption}-${index}`"
          :advanced_option="advancedOption"
          :questions_groups_index="questions_groups_index"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Arrow from '@/components/imgs/ArrowExpandGroup'

import { groupAdvancedOptionsToRenderConfig } from '@/utils/groupAdvancedOptions'

import Checkbox from './inputs/Checkbox'
import GroupNumberInput from './inputs/Number'

import * as translationModalMedia from '../MediaModal.translations'

const { default: translations, ...translationKeys } = translationModalMedia

export default {
  name: 'GroupAdvancedOptions',

  components: { Checkbox, GroupNumberInput, Arrow },

  props: {
    questions_groups_index: {
      required: true,
      type: Number,
    },
    expandAll: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      groupAdvancedOptionsToRenderConfig,
      collapseGroupAdvancedOptions: false,
    }
  },

  computed: {
    ...mapState(['questionGroups']),
  },

  watch: {
    expandAll() {
      this.collapseGroupAdvancedOptions = !!this.expandAll
    },
  },

  methods: {
    optionsToRender() {
      return Object.keys(groupAdvancedOptionsToRenderConfig).filter(advancedOption =>
        groupAdvancedOptionsToRenderConfig[advancedOption]?.shouldDisplayChecker
          ? groupAdvancedOptionsToRenderConfig[advancedOption].shouldDisplayChecker(
              this.questionGroups[this.questions_groups_index],
            )
          : true,
      )
    },

    getComponent(type) {
      switch (type) {
        case 'boolean':
          return 'Checkbox'
        case 'number':
          return 'GroupNumberInput'

        default:
          return console.error(
            `${type} ${this.translations[this.language][this.DEFAULT_SWITCH]}`,
          )
      }
    },

    collapse() {
      this.collapseGroupAdvancedOptions = !this.collapseGroupAdvancedOptions
    },
  },
}
</script>

<style lang="scss" scoped>
.expandPanel {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border: none;
  width: 100%;
  cursor: pointer;
  font-size: inherit;
  background: none;

  &:focus {
    outline: none;
  }

  p {
    @include tipography(18);
    font-weight: bold;
    white-space: nowrap;
  }

  span {
    @include flexAlignCenter;
    svg {
      @include boxSizing(15);
    }

    margin-left: 10px;
    transition: all 0.3s ease-in;
    transform: rotate(180deg);

    &.active {
      transform: rotate(0);
    }
  }

  &::after,
  &::before {
    content: '';
    display: block;
    width: 40px;
    height: 1px;
    background: $white;
    margin: 0 10px 0 0;
  }

  &::after {
    width: 100%;
    margin: 0 0 0 10px;
  }

  .light & {
    color: $gray-6;
    &::after,
    &::before {
      background: $gray-5;
    }

    p {
      color: $gray-6;
    }
  }
}

.collapsePanel {
  animation: growDown 400ms ease-in-out forwards;
  transform-origin: top center;
  > div {
    padding: 5px 10px;
  }
}
</style>
